import { render } from "./ListRefresh.vue?vue&type=template&id=50636568&scoped=true&ts=true"
import script from "./ListRefresh.vue?vue&type=script&lang=ts"
export * from "./ListRefresh.vue?vue&type=script&lang=ts"

import "./ListRefresh.vue?vue&type=style&index=0&id=50636568&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50636568"]])

export default __exports__